module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-statebrowser-network",
    class: [
      _vm.isActiveNetwork ? 'kiwi-statebrowser-network--active' : '' ]
  }, [_c('div', {
    staticClass: "kiwi-statebrowser-network-header"
  }, [_c('a', {
    staticClass: "kiwi-statebrowser-network-name u-link",
    on: {
      "click": function($event) {
        _vm.setActiveBuffer(_vm.network.serverBuffer())
      }
    }
  }, [_vm._v(_vm._s(_vm.network.name))]), _vm._v(" "), (_vm.network.buffers.length > 1) ? _c('a', {
    staticClass: "kiwi-statebrowser-network-toggle",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.collapsed ? 'fa-plus-square-o' : 'fa-minus-square-o'],
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-statebrowser-network-toggable-area",
    class: [
      _vm.collapsed ? 'kiwi-statebrowser-network-toggable-area--collapsed' : '' ]
  }, [_c('transition', {
    attrs: {
      "name": "kiwi-statebrowser-network-status-transition"
    }
  }, [(_vm.network.state !== 'connected') ? _c('div', {
    staticClass: "kiwi-statebrowser-network-status"
  }, [(_vm.network.state_error) ? [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": function($event) {
        _vm.showNetworkSettings(_vm.network)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('state_configure')))])] : (!_vm.network.connection.server) ? [_c('a', {
    staticClass: "u-link",
    on: {
      "click": function($event) {
        _vm.showNetworkSettings(_vm.network)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('state_configure')))])] : (_vm.network.state === 'disconnected') ? [_vm._v("\n                " + _vm._s(_vm.$t('state_disconnected')) + "\n                "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": function($event) {
        _vm.network.ircClient.connect()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('connect')))])] : (_vm.network.state === 'connecting') ? [_vm._v("\n                " + _vm._s(_vm.$t('connecting')) + "\n            ")] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-statebrowser-channels"
  }, _vm._l((_vm.orderedBuffers(_vm.network.buffers)), function(buffer) {
    return _c('div', {
      staticClass: "kiwi-statebrowser-channel",
      class: {
        'kiwi-statebrowser-channel-active': _vm.isActiveBuffer(buffer),
          'kiwi-statebrowser-channel-notjoined': buffer.isChannel() && !buffer.joined
      }
    }, [_c('div', {
      staticClass: "kiwi-statebrowser-channel-name",
      on: {
        "click": function($event) {
          _vm.setActiveBuffer(buffer)
        }
      }
    }, [_vm._v(_vm._s(buffer.name))]), _vm._v(" "), _c('div', {
      staticClass: "kiwi-statebrowser-channel-labels"
    }, [_c('transition', {
      attrs: {
        "name": "kiwi-statebrowser-channel-label-transition"
      }
    }, [(buffer.flags.unread) ? _c('div', {
      staticClass: "kiwi-statebrowser-channel-label",
      class: {
        'kiwi-statebrowser-channel-label--highlight': buffer.flags.highlight
      }
    }, [_vm._v("\n                        " + _vm._s(buffer.flags.unread) + "\n                    ")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "kiwi-statebrowser-channel-settings",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.$emit('showBufferSettings', buffer, $event.clientY)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bell-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  })), _vm._v(" "), (_vm.network.state === 'connected') ? _c('form', {
    staticClass: "kiwi-statebrowser-newchannel",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitNewChannelForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-statebrowser-newchannel-inputwrap",
    class: [
      _vm.new_channel_input_has_focus ?
      'kiwi-statebrowser-newchannel-inputwrap--focus' :
      ''
    ]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_channel_input),
      expression: "new_channel_input"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('state_join')
    },
    domProps: {
      "value": (_vm.new_channel_input)
    },
    on: {
      "focus": _vm.onNewChannelInputFocus,
      "blur": _vm.onNewChannelInputBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_channel_input = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.submitNewChannelForm
    }
  })])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f93415c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StateBrowserNetwork.vue
// module id = 481
// module chunks = 2